import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAllQuizzes } from '../data/quizRegistry';
import { updateMetaTags } from '../utils/seoHelpers';
import QuizCard from '../components/QuizCard';
import AggregateScore from '../components/AggregateScore';
import QuizBadges from '../components/QuizBadges';
import TodayCounter from '../components/TodayCounter';
import AdUnit from '../ads/AdUnit';
import '../styles/quizHub.css';

const QuizHub: React.FC = () => {
  const [searchParams] = useSearchParams();
  const challengeScore = searchParams.get('challenge');
  const quizzes = getAllQuizzes();

  useEffect(() => {
    updateMetaTags(
      '건강 테스트 모음 - 나의 건강 점수는?',
      '기대수명, 치매 위험도, 스트레스 지수, 수면 건강, 정신건강까지! 5가지 건강 테스트로 나의 건강을 종합 진단해보세요.',
    );
  }, []);

  return (
    <div className="hub-wrapper">
      <div className="hub-container">
        {challengeScore && (
          <div style={{
            background: 'linear-gradient(135deg, #FF6B6B, #FF8E53)',
            color: '#fff',
            borderRadius: '16px',
            padding: '16px 24px',
            marginBottom: '16px',
            textAlign: 'center',
            boxShadow: '0 4px 12px rgba(255,107,107,0.3)',
            animation: 'dyongEffect 0.5s ease-in-out 3',
            width: '100%',
            maxWidth: '500px',
          }}>
            <div style={{ fontSize: '14px', marginBottom: '4px' }}>🔥 친구의 도전장!</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
              "나는 {challengeScore}살까지 산다!"
            </div>
            <div style={{ fontSize: '13px', marginTop: '4px' }}>너는 몇 살까지 살 수 있어?</div>
          </div>
        )}

        <div className="hub-title">🏥 건강 테스트 모음</div>
        <div className="hub-subtitle">5가지 테스트로 나의 건강을 종합 진단해보세요</div>

        <TodayCounter />
        <AggregateScore />
        <QuizBadges />

        <div className="quiz-card-grid">
          {quizzes.map((quiz, index) => (
            <React.Fragment key={quiz.id}>
              <QuizCard quiz={quiz} />
              {index === 1 && <AdUnit format="inarticle" slot="7202974220" />}
            </React.Fragment>
          ))}
        </div>

      </div>
    </div>
  );
};

export default QuizHub;
